<template>
    <div v-if="showApp">
        <page-pdf-signer></page-pdf-signer>
    </div>
</template>
  
<script>

import PagePdfSigner from "@/projects/pdf-signer/components/pdf-tabs.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PagePdfSigner,
    },
};
</script>
  
<style></style>